/**
 * Design-system breakpoints aligned with StremHub UI Kit (Figma).
 *
 * Mirrors `src/styles/mixins/_breakpoints.scss`. Keep both files in sync.
 */

/** Mobile-first `min-width` thresholds (px) for media queries and JS. */
export const breakpointMin = {
  tablet: 769,
  tabletLg: 1024,
  desktop: 1025,
  desktopLg: 1440,
  ultra: 1921,
  ultraWide: 2559,
} as const

/**
 * Split used by `useIsMobile()` and sidebar layout: viewport width < tablet min.
 */
export const TABLET_BREAKPOINT = breakpointMin.tablet

export type BreakpointMinKey = keyof typeof breakpointMin

/** Build a `min-width` media query string, e.g. for styled-jsx or tests. */
export function minWidthQuery(tier: BreakpointMinKey): string {
  return `(min-width: ${breakpointMin[tier]}px)`
}
